import type { RouteRecordRaw } from "vue-router";

import { getRouteParam, getRouteParamOrEmpty } from "../utils";

export const remitRoutes: RouteRecordRaw[] = [
  {
    path: "/remit/:organizationId",
    name: "remit",
    component: () => import(/* webpackChunkName: "dashboard-remit" */ "../../components/remit/RemitView.vue"),
    props: route => ({
      organizationId: getRouteParamOrEmpty(route, "organizationId")
    }),
    meta: { titleKey: "pageTitle.remit", viewGroup: "remit", viewGroupParams: ["organizationId"] }
  },
  {
    path: "/remit/:organizationId/allocations",
    name: "remit-allocations",
    component: () =>
      import(/* webpackChunkName: "dashboard-remit-allocations" */ "../../components/remit/RemitAllocationView.vue"),
    props: route => ({
      organizationId: getRouteParamOrEmpty(route, "organizationId")
    }),
    meta: { titleKey: "pageTitle.remit", viewGroup: "remit-allocations", viewGroupParams: ["organizationId"] }
  },
  {
    path: "/remit/:organizationId/creditors",
    name: "remit-creditors",
    component: () =>
      import(/* webpackChunkName: "dashboard-remit-creditors" */ "../../components/remit/RemitCreditorView.vue"),
    props: route => ({
      organizationId: getRouteParamOrEmpty(route, "organizationId")
    }),
    meta: { titleKey: "pageTitle.remit", viewGroup: "remit-creditors", viewGroupParams: ["organizationId"] }
  },
  {
    path: "/remit/:organizationId/:tab",
    name: "remit-tab",
    component: () => import(/* webpackChunkName: "dashboard-remit" */ "../../components/remit/RemitView.vue"),
    props: route => ({
      organizationId: getRouteParamOrEmpty(route, "organizationId"),
      tab: getRouteParam(route, "tab")
    }),
    meta: { titleKey: "pageTitle.remit", viewGroup: "remit", viewGroupParams: ["organizationId"] }
  }
];
